import _ea from "./in-app-message-manager.js";
import r from "../managers/braze-instance.js";
var se = {
  aa: null,
  i: !1,
  ea: function ea() {
    return se.t(), se.aa || (se.aa = new _ea(r.m(), r.u(), r.p(), r.ir())), se.aa;
  },
  t: function t() {
    se.i || (r.g(se), se.i = !0);
  },
  destroy: function destroy() {
    se.aa = null, se.i = !1;
  }
};
export default se;